// extracted by mini-css-extract-plugin
module.exports = {"component":"badge_component__Q3aRw","component_text":"badge_component_text__qSzb0"};